import { GasBurnerIcon } from './GasBurnerIcon';

/**
 * author: Austin Andrews
 * id BB98FED5-2967-4D6D-B133-8447CE90C089
 * name gas-burner
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gas-burner.svg
 * tags
 * - Home Automation 
 */
export const CooktopBurnerIcon = GasBurnerIcon;
export default CooktopBurnerIcon